import Header from "../Header";
import React, {useEffect, useState} from "react";
import {useForm} from "react-hook-form";
import {createConditionalRequire, createValueGroupRequired} from '../../utils';
import {submitStep} from "../../network";
import ReactGA from "react-ga";

/*
const kadriPictures = [
    require("../profile_pictures/kadri/kadri_mannimets1.jpg"),
    require("../profile_pictures/kadri/kadri_mannimets2.jpg"),
    require("../profile_pictures/kadri/kadri_mannimets3.jpg"),
    require("../profile_pictures/kadri/kadri_mannimets4.jpg"),
    require("../profile_pictures/kadri/kadri_mannimets5.jpg"),
    require("../profile_pictures/kadri/kadri_mannimets6.jpg"),
];
const kadriPicture = kadriPictures[Math.floor(Math.random() * kadriPictures.length)]
*/
const teachersAssistants = [
    /*
        {
            name: "Anastassia Voronina",
            languages: ['🇷🇺'],
            picture: require("../profile_pictures/anastassia_voronina.jpg")
        },
        {
            name: "Anton Matskevitš",
            languages: ['🇷🇺'],
            picture: require("../profile_pictures/anton_matskevits.png")
        },
        {
            name: "Diana Christine Tarro",
            picture: require("../profile_pictures/diana_christine_tarro.jpg")
        },
        {
            name: "Edvin Mihhailov",
            picture: require("../profile_pictures/edvin_mihhailov.jpg")
        },
        {
            name: "Henri Keerutaja",
            picture: require("../profile_pictures/henri_keerutaja.jpg")
        },
        {
            name: "Kadri Männimets",
            picture: kadriPicture
        },
        {
            name: "Kaisa-Mari Veinberg",
            picture: require("../profile_pictures/kaisa-mari_veinberg.jpg")
        },
        {
            name: "Kalev Kilumets",
            picture: require("../profile_pictures/cat.jpg")
        },

        {
            name: "Karl Raud",
            picture: require("../profile_pictures/karl_raud.jpg")
        },
        {
            name: "Kaspar Ustav",
            picture: require("../profile_pictures/kaspar_ustav.JPG")
        },
        {
            name: "Kristjan Kõiv",
            picture: require("../profile_pictures/kristjan_k6iv.jpg")
        },
        {
            name: "Lauri Simulman",
            picture: require("../profile_pictures/lauri_simulman.jpg")
        },
        {
            name: "Marcus Pruks",
            picture: require("../profile_pictures/marcus_pruks.jpg")
        },
        {
            name: "Maria Gazieva",
            languages: ['🇷🇺'],
            picture: require("../profile_pictures/cat.jpg")
        },
        {
            name: "Maria Kaasik-Aaslav",
            picture: require("../profile_pictures/maria_kaasik-aaslav.jpg")
        },
        {
            name: "Mihkel Oper",
            picture: require("../profile_pictures/mihkel_oper.png")
        },
        {
            name: "Nele Sergejeva",
            picture: require("../profile_pictures/nele_sergejeva.jpg")
        },
        {
            name: "Peeter Maran",
            picture: require("../profile_pictures/peeter_maran.jpg")
        },
        {
            name: "Rasmus Maipuu",
            picture: require("../profile_pictures/rasmus_maipuu.jpg")
        },
        {
            name: "Siim Martin Saarts",
            picture: require("../profile_pictures/siim_martin_saarts.jpg")
        }
        */

    ]
;
const agoPicture = require("../profile_pictures/ago_luberg.jpg");
const ahtiPicture = require("../profile_pictures/ahti_lohk.jpg");

const TeacherAndStudents = ({nextStep, currentFormStep, maxStep}) => {
    useEffect(() => {
        ReactGA.pageview(window.location.pathname + "/teacherAndStudents");
    }, []);
    const [isLoading, setLoading] = useState(false);
    const onSubmit = data => {
        setLoading(true)
        submitStep("teacher and students", data)
            .then(() => {
                setLoading(false)
                nextStep()
            })
    };
    const {register, handleSubmit, errors, getValues} = useForm();

    return (<>
        <Header title="Saame tuttavaks"/>
        <progress className="progress is-link" value={currentFormStep} max={maxStep}/>
        <section className="section">
            <div className="container">
                <p className="text">
                    Meie aines osaleb sel aastal üle 500 tudengi. Selleks, et igaüks saaks vajadusel abi, on meil suur
                    tiim! Allpool tutvustame Sulle ennast ja siis küsime Sinu kohta ühe olulise küsimuse!
                </p>
            </div>
            <div className="container">
                <h1 className="subtitle">
                    Õppejõudude tiim
                </h1>
            </div>
            <div className="container">
                <img className="profile-picture" src={agoPicture}/>
                <p className="text">
                    Mina olen <strong>Ago Luberg</strong>, vastutan päevaõppe eest. Näed mind kõikidel loengutel ja võid
                    minu poole igal ajal pöörduda – koputa õlale, kirjuta e-kiri ago.luberg@taltech.ee või saada
                    privaatne sõnum Discordis (vt allpool). Et ma ei jääks vaid avatariks, tegin väikese video!
                </p>
                <figure className="image video-container">
                    <iframe className="has-ratio video-iframe"
                            src="https://www.youtube.com/embed/p21LfA2Ux74?showinfo=0" frameborder="0"
                            allowfullscreen/>
                </figure>
            </div>
            <div className="container">
                <img className="profile-picture" src={ahtiPicture}/>
                <p className="text">
                    Mina olen <strong>Ahti Lohk</strong> ja vastutan sessioonõppe eest. Minuga saab ühendust:
                    ahti.lohk@taltech.ee .
                </p>
            </div>
            <div className="container">
                <h1 className="subtitle">
                    Abiõppejõud:
                </h1>
                <div className="text">
                    Meie tiimis on ka mitu abiõppejõudu, kes kõik on selle kursuse edukalt läbinud tudengid.
                    Abiõppejõude näed Sa seminarides ja ülesannete kaitsmisel - nad aitavad Sind hea meelega!
                    Meil on kogemus, et igaüks, kes on natuke pingutanud ja vajadusel abi küsinud, on kursuse edukalt ka
                    läbinud!
                </div>
                <div className="profiles">
                    {
                        teachersAssistants.map(assistant => (<div className="profile">
                            <img className="profile-picture" src={assistant.picture}/>
                            <h2 className="profile-name">
                                {assistant.name} <span>🇪🇪</span> <span>🇬🇧</span>
                                {assistant.languages ? assistant.languages.map(lang => (
                                    <span>{lang}</span>
                                )) : null}
                            </h2>
                        </div>))
                    }
                </div>
            </div>
            <div className="container">
                <h1 className="subtitle">
                    Discord omavahel suhtlemiseks
                </h1>
                <p className="text">
                    Lisaks loengutele, mida saab vaadata ka videotena, ja seminaridele, kus näeme üksteist kord
                    nädalas, saavad kõik omavahel suhelda ka virtuaalselt, kasutades selleks
                    suhtlemisrakendust <strong>Discord</strong>. <a href="https://discord.gg/3pg2sNUStB"
                                                                    target="_blank">Vajuta
                    siia</a>, et luua endale kasutaja ja liituda aine grupiga.
                </p>
            </div>
            <div className="container">
                <h1 className="subtitle">
                    Räägi natuke endast!
                </h1>
                <p className="text">
                    Oleme seda kursust teinud üle 8 aasta ja teame, et kõik inimesed on väga erinevad.
                    Oleme kogenud, et Sul võib tekkida ühel hetkel tunne, et see aine või isegi
                    õppekava ei ole Su jaoks õige koht. Vahel aitab, kui tunnistame, et selline mõte on ka meid tabanud.
                    Sellise tunde tekkimist ei pea kartma. Meie abilistega oleme siin selleks, et Sind aidata - ära anna alla!
                </p>
            </div>
            <form className="container" onSubmit={handleSubmit(onSubmit)}>
                <h1 className="subtitle form-question">
                    Meil on suur abi sellest, kui võtad hetke mõelda ja annad märku, kus Sa omadega praegu oled?
                </h1>
                <div className="control">
                    <label className="checkbox">
                        <input type="checkbox" name="answer.noIssues"
                               ref={register(createValueGroupRequired(getValues, 'answer'))}/>
                        Mul on kõik hästi
                    </label>
                </div>
                <div className="control">
                    <label className="checkbox">
                        <input type="checkbox" name="answer.languageBarrier"
                               ref={register(createValueGroupRequired(getValues, 'answer'))}/>
                        Muretsen, et mul võib mõnel hetkel tekkida raskusi eesti keelega
                    </label>
                </div>
                <div className="control">
                    <label className="checkbox">
                        <input type="checkbox" name="answer.familyIssues"
                               ref={register(createValueGroupRequired(getValues, 'answer'))}/>
                        Kursuse jooksul võivad tekkida perekondlikud mured (või rõõmud), mis segavad
                    </label>
                </div>
                <div className="control">
                    <label className="checkbox">
                        <input type="checkbox" name="answer.work"
                               ref={register(createValueGroupRequired(getValues, 'answer'))}/>
                        Käin tööl ja see võib ühel hetkel segada aines osalemist
                    </label>
                </div>
                <div className="control">
                    <label className="checkbox">
                        <input type="checkbox" name="answer.healthIssues"
                               ref={register(createValueGroupRequired(getValues, 'answer'))}/>
                        Mu tervis võib segada pingutamast nii palju, kui tahaksin
                    </label>
                </div>
                <div className="control">
                    <label className="checkbox">
                        <input type="checkbox" name="answer.tooHard"
                               ref={register(createValueGroupRequired(getValues, 'answer'))}/>
                        Ma muretsen, et ei saa ainega hakkama, kuna pole varem programmeerinud
                    </label>
                </div>
                <div className="control">
                    <label className="checkbox">
                        <input type="checkbox" name="answer.otherProblems"
                               ref={register(createValueGroupRequired(getValues, 'answer'))}/>
                        Mul on muu mure (palun kirjuta allpool, milles mure ja kuidas saame Sind aidata)
                    </label>
                    <input name="answerOtherProblems"
                           ref={register(createConditionalRequire(getValues, "answer.otherProblems", true))}
                           className="input" type="text"/>
                </div>
                <h1 className="subtitle form-question">
                    Kas võiksime midagi veel Sinu kohta teada?
                </h1>
                <textarea className="textarea"
                          name="aboutStudent"
                          ref={register({required: false})}
                          placeholder="Kirjuta siia endast"></textarea>
                {Object.keys(errors).length ? <div className="validation-error">
                    Jätkamiseks vali vähemalt üks valikutest
                </div> : null}
                <button className={`button is-large is-rounded take-test-button ${isLoading ? 'is-loading' : ''}`}
                        disabled={isLoading}>JÄRGMINE →
                </button>
            </form>
        </section>
    </>);
};

export default TeacherAndStudents;
